import { ListItem, ListItemText, styled } from '@material-ui/core'

const StyledListItem = styled(ListItem)(({ isSelected }) => {
  return {
    backgroundColor: isSelected ? 'rgba(0,0,0,0.05)' : 'inherit',
    padding: '10px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.05)',
    },
  }
})
export const InterlocutorItem = ({
  index,
  interlocutor,
  interlocutorSelectedIndex,
  handleSelectInterlocutor,
}) => {
  return (
    <StyledListItem
      key={`interlocutor-${index + 1}`}
      button
      onClick={() =>
        handleSelectInterlocutor(
          interlocutor.phone,
          `interlocutor-${index + 1}`,
          interlocutor
        )
      }
      isSelected={interlocutorSelectedIndex === `interlocutor-${index + 1}`}
    >
      <ListItemText
        primaryTypographyProps={{ variant: 'h6', fontWeight: 'medium' }}
        secondaryTypographyProps={{
          variant: 'body2',
          color: 'textSecondary',
        }}
        primary={interlocutor.fullname}
        secondary={interlocutor.phone}
      />
    </StyledListItem>
  )
}
export default InterlocutorItem
